import React from 'react'
import './myproducts.css'
import ConnectorPanel from './ConnectorPanel/ConnectorPanel'

const MyProducts = () => (
    <div className="main-content myProducts newMyProducts">
        <div className="page-content pb-0">
            <div className="container-fluid">
                <ConnectorPanel />
            </div>
        </div>
    </div>
)

export default MyProducts
